import React, { lazy } from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { MapPin, Phone, Clock } from 'lucide-react';
export function LocationSection() {
  return <section className="py-20 bg-white" data-id="element-247">
      <Container data-id="element-248">
        <div className="text-center mb-12" data-id="element-249">
          <h2 className="text-3xl md:text-4xl font-extrabold text-nav mb-4 uppercase tracking-tight font-heading" data-id="element-250">
            Visit Dragon Martial Arts of Round Lake
          </h2>
          <div className="w-20 h-1 bg-accent mx-auto mb-6" data-id="element-251"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-252">
          {/* Info */}
          <div className="bg-gray-50 p-8 rounded-lg border border-gray-200 h-full" data-id="element-253">
            <div className="space-y-8" data-id="element-254">
              <div className="flex items-start" data-id="element-255">
                <div className="bg-accent/10 p-3 rounded-full mr-4" data-id="element-256">
                  <MapPin className="w-6 h-6 text-accent" data-id="element-257" />
                </div>
                <div data-id="element-258">
                  <h3 className="font-bold text-nav text-xl mb-2" data-id="element-259">Location</h3>
                  <p className="text-gray-600" data-id="element-260">
                    655 Railroad Ave.
                    <br data-id="element-261" />
                    Round Lake, IL 60073
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-262">
                <div className="bg-accent/10 p-3 rounded-full mr-4" data-id="element-263">
                  <Phone className="w-6 h-6 text-accent" data-id="element-264" />
                </div>
                <div data-id="element-265">
                  <h3 className="font-bold text-nav text-xl mb-2" data-id="element-266">Contact</h3>
                  <a href="tel:8472128045" className="text-lg text-link hover:text-accent font-bold transition-colors" data-id="element-267">
                    (847) 212-8045
                  </a>
                </div>
              </div>

              <div className="flex items-start" data-id="element-268">
                <div className="bg-accent/10 p-3 rounded-full mr-4" data-id="element-269">
                  <Clock className="w-6 h-6 text-accent" data-id="element-270" />
                </div>
                <div data-id="element-271">
                  <h3 className="font-bold text-nav text-xl mb-2" data-id="element-272">Hours</h3>
                  <ul className="space-y-1 text-gray-600" data-id="element-273">
                    <li className="flex justify-between w-full max-w-xs" data-id="element-274">
                      <span data-id="element-275">Mon – Fri:</span>
                      <span className="font-medium" data-id="element-276">3:00 pm – 8:00 pm</span>
                    </li>
                    <li className="flex justify-between w-full max-w-xs" data-id="element-277">
                      <span data-id="element-278">Saturday:</span>
                      <span className="font-medium" data-id="element-279">9:00 am – 1:00 pm</span>
                    </li>
                    <li className="flex justify-between w-full max-w-xs" data-id="element-280">
                      <span data-id="element-281">Sunday:</span>
                      <span className="text-accent font-medium" data-id="element-282">Closed</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="mt-10 pt-8 border-t border-gray-200" data-id="element-283">
              <p className="text-sm text-gray-500 leading-relaxed italic" data-id="element-284">
                Dragon Martial Arts of Round Lake proudly serves: Fox Lake,
                Village of Spring Grove, Round Lake, McHenry, Gurnee as well as
                all surrounding areas!
              </p>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-4" data-id="element-285">
              <a href="#signup" className="flex-1" data-id="element-286">
                <Button variant="primary" fullWidth data-id="element-287">
                  Get One Week Free Trial
                </Button>
              </a>
              <a href="tel:8472128045" className="flex-1" data-id="element-288">
                <Button variant="secondary" fullWidth className="!text-nav !border-nav hover:!bg-nav hover:!text-white" data-id="element-289">
                  Call (847) 212-8045
                </Button>
              </a>
            </div>
          </div>

          {/* Map Placeholder */}
          <div className="h-full min-h-[400px] bg-gray-200 rounded-lg overflow-hidden relative shadow-inner" data-id="element-290">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2956.687654321!2d-88.0!3d42.3!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDLCsDE4JzAwLjAiTiA4OMKwMDAnMDAuMCJX!5e0!3m2!1sen!2sus!4v1600000000000!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen={true} loading="lazy" title="Dragon Martial Arts Location" className="absolute inset-0 w-full h-full" data-id="element-291"></iframe>
          </div>
        </div>
      </Container>
    </section>;
}